import { ValColumnEnum } from '@shared-app/lib/types';
export const extractData = (arr, field) => {
    if (field === ValColumnEnum.systems || field === ValColumnEnum.types) {
        const dataSet = new Set();
        arr.forEach(item => {
            const arrayValue = item[field];
            if (Array.isArray(arrayValue)) {
                arrayValue.forEach(value => dataSet.add(value));
            }
        });
        return Array.from(dataSet);
    }
    const dataSet = new Set(arr.map(item => item[field]).filter(Boolean));
    return Array.from(dataSet);
};
